import { render, staticRenderFns } from "./CourseSelector.vue?vue&type=template&id=273eb642&scoped=true"
import script from "./CourseSelector.vue?vue&type=script&lang=ts"
export * from "./CourseSelector.vue?vue&type=script&lang=ts"
import style0 from "./CourseSelector.vue?vue&type=style&index=0&id=273eb642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273eb642",
  null
  
)

export default component.exports